<template>
<div class="wrap">
  <div class="zpxq">
    <img src="@/assets/img/xinxi_title.png" alt="" class="xinxi_title">
    <div class="zhu zi10">
      *注：门票为特殊商品不予退换，请仔细核对信息后填写
    </div>
    <van-form @submit="onSubmit" class="zi10">
      <van-field
        class="production"
        v-model="form.name"
        name="姓名"
        label="姓名"
        placeholder="请输入姓名"
        required
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="form.phone"
        name="手机号"
        label="手机号"
        placeholder="请输入手机号"
        required
        type="tel" 
        maxlength="11"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field
        class="production"
        v-model="form.idCard"
        name="身份证号"
        label="身份证号"
        placeholder="请输入身份证号"
        required
        :rules="[{ required: true, message: '请填写身份证号' }]"
      />
      <van-field
        class="production"
        v-model="form.address"
        name="联系地址"
        label="联系地址"
        placeholder="请输入联系地址"
        required
        :rules="[{ required: true, message: '请填写联系地址' }]"
      />
      <div class="footerBtn" v-if="!isonfocus">
        <van-button class="submit" round block type="info" native-type="submit"
          ><div class="flex aic">提 交  <van-loading style="margin-left: 10px;" type="spinner" color="#fff" v-if="loading" /></div>
          </van-button
        >
      </div>
    </van-form>


    
    <van-overlay :show="showbm" z-index="999" class-name="overlay">
      <div class="wrapper po_r">
        <img src="@/assets/img/close.png" alt="" class="close" @click="close">

      </div>
    </van-overlay>
  </div>
  <div class="zpxq1">
    <img src="@/assets/img/menpiao_title.png" alt="" class="xinxi_title">
    <div class="dishi" v-for="(item,index) in menpiao" :key="index">
      <div class="ds_wrap">
        <div class="dishi1 flex aic jcs" @click="dishiclick(item)">
          <div class="flex aic">
            <img src="@/assets/img/ding.png" alt="" class="ding_img" v-if="!item.isopen">
            <img src="@/assets/img/ding_s.png" alt="" class="ding_img" v-if="item.isopen">
            <p>{{item.name}}</p>
          </div>
          <div>
            <img src="@/assets/img/bottom.png" alt="" class="bottom_img" v-if="!item.isopen">
            <img src="@/assets/img/top.png" alt="" class="top_img" v-if="item.isopen">
          </div>
        </div>
        <div class="dishi2" v-if="item.isopen">
          <div class="dishi3 flex aic jcs"  v-for="(item1,index1) in item.children" :key="index1" @click="piaoclick(item1)" :class="{active:item1.issel,disable:item1.isover}">
            <div class="flex aic">
              <h6>{{item1.name}}</h6>
            </div>
            <div class="flex aic">
              <p>1张（每个有效证件限选1张）</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  
    <img src="@/assets/img/hdgz.png" class="hdgz_img" @click="hdgzclick"/>
      
    <van-overlay :show="showbm1" z-index="99" class-name="overlay1"  :lock-scroll="false">
      <div class="wrapper po_r ">
        <img src="@/assets/img/close.png" alt="" class="close" @click="close1">
          <div class="overlay_title">
            <span>领取须知</span>
          </div>
          <div class="jp jp1" >
            <div>
              <h1>一、兑奖方式</h1>
              <p>1.获奖者凭获奖登记信息，持身份证原件到中奖对应景区售票处核实信息后，方可入园/馆免费参观(仅限当日入园/馆)。</p>
              <p>2.殷墟博物馆、殷墟宫殿宗庙遗址、洹河夜游、殷墟考古文旅小镇、方城七峰山5个景区为纸质门票，获奖者需凭票进入景区游览。门票将在活动结束后7个工作日内统一邮寄，请注意查收。</p>
              <h1>二、注意事项</h1>
              <p>1.本次活动门票有效期为2025年1月1日至2025年11月29日。</p>
              <p>2.请提前查询景区开闭时间，避免跑空。</p>
              <p>3.兑换过程中如有任何疑问或需要帮助，请联系张老师，联系电话：0371-65902664。</p>
              <p><mark>注：本次答题活动不能查询获奖纪录，如有需要，请截图保留凭证。</mark></p>
            </div>
          </div>
          <van-button v-if="!iszhidao" class="submit" round block type="info" @click="zhidao" native-type="submit"
            ><div class="flex aic">我 知 道 了</div>
            </van-button
          >
      </div>
    </van-overlay>
</div>
</template>
<script>

export default {
  name: "Bm",
  data() {
    return {
      form:{
        name:'',//姓名，type=1时必填 
        phone:'',//手机号
        idCard:'',//地址
        address:'',//地址
      },
      isonfocus:false,
      showbm:false,
      showbm1:false,
      iszhidao:false,
      loading:false,
      menpiao:[
        {
          name:'焦作市',
          isopen:false,
          children:[
            {name:'神农山',num:500,code:'SNS',issel:false,isover:false},
          ]
        },
        {
          name:'洛阳市',
          isopen:false,
          children:[
            {name:'老君山',num:300,code:'LJS',issel:false,isover:false}
          ]
        },
        {
          name:'三门峡市',
          isopen:false,
          children:[
            {name:'陕州地坑院',num:100,code:'DKY',issel:false,isover:false}
          ]
        },
        {
          name:'新乡市',
          isopen:false,
          children:[
            {name:'八里沟',num:30,code:'BLG',issel:false,isover:false},
            {name:'关山国家地质公园',num:30,code:'GS',issel:false,isover:false},
            {name:'万仙山',num:30,code:'WXS',issel:false,isover:false}
          ]
        },
        {
          name:'南阳市',
          isopen:false,
          children:[
            {name:'七峰山',num:200,code:'QFS',issel:false,isover:false},
            {name:'社旗山陕会馆',num:200,code:'SSHG',issel:false,isover:false},
          ]
        },
        {
          name:'安阳市',
          isopen:false,
          children:[
            {name:'羑里城',num:100,code:'YLC',issel:false,isover:false},
            {name:'殷墟博物馆',num:50,code:'YXBWG',issel:false,isover:false},
            {name:'殷墟宫殿宗庙遗址',num:50,code:'YXGD',issel:false,isover:false},
            {name:'洹河夜游',num:50,code:'HHYY',issel:false,isover:false},
            {name:'殷墟考古文旅小镇',num:50,code:'YXXZ',issel:false,isover:false},
            {name:'曹操高陵遗址博物馆',num:100,code:'CCGL',issel:false,isover:false},
            {name:'马氏庄园',num:100,code:'MSZY',issel:false,isover:false},
            {name:'汤阴岳飞庙',num:100,code:'YFM',issel:false,isover:false},
          ]
        },
      ]
    };
  },
  // 卸载时移除分享按钮
  // destroyed(){
  //   // wx.showOptionMenu()
  // },
  mounted() {
    // 打开分享按钮
    // wx.hideOptionMenu()
    // 获取视图原始高度
    let screenHeight = document.body.offsetHeight
    // 为window绑定resize事件
    window.onresize = function () {
      let nowHeight = document.body.offsetHeight
      if (nowHeight < screenHeight) {
        // 将底部弹起的按钮隐藏（可使用给按钮添加相应消失类）
        this.isonfocus = true;
      } else {
        // 将按钮正常显示（可使用给按钮移除相应消失类）
        this.isonfocus = false;
      }
    }
  },
  methods: {
    zhidao(){
      this.iszhidao = true
      this.close1()
    },
    hdgzclick(){
      this.showbm1 = true
    },
    close1(){
      this.showbm1 = false
    },
    dishiclick(item){
      this.menpiao.map(s=>{
        if(s.name == item.name){
          if(s.isopen){
            s.isopen = false
          }else{
            s.isopen = true
          }
        }else{
          s.isopen = false
        }
      })
      // item.isopen = !item.isopen
    },
    piaoclick(item){
      if(item.isover){
        return
      }
      this.menpiao.map(s=>{
        s.children.map(c=>{
          c.issel = false
        })
      })
      item.issel = true
    },
    zjcx(){
      this.showbm = true
    },
    close(){
      this.showbm = false
    },
    onSubmit(values) {
      console.log("submit", values);
      if(!this.iszhidao){
        this.hdgzclick()
        return
      }
      if(this.loading){
        return
      }
      // this.showbm = true
      // return
      let mp_info = {
        code:'',
        name:''
      }
      this.menpiao.map(s=>{
        s.children.map(c=>{
          if(c.issel){
            mp_info = c
          }
        })
      })
      if(!mp_info.code){
        this.$toast.fail('请选择门票');
        return
      }
      let {
        name,//姓名，type=1时必填
        phone,//手机号
        idCard,//身份证
        address,//身份证
      } = this.form
      let obj = {
        openId:localStorage.q,
        name,//姓名，type=1时必填
        phone,//手机号
        idCard,//身份证
        address,//身份证
        code:mp_info.code,//身份证
      }
      console.log(obj);
      this.$dialog.confirm({
        title: '温馨提示',
        message: `确定选择门票：${mp_info.name}吗？`,
      })
        .then(() => {
          // on confirm
          this.loading = true
          let toast = this.$toast.loading({
            duration:0,
            message: '提交中...',
            forbidClick: true,
            loadingType: 'spinner',
          });
          this.$store.dispatch('works_add',obj).then(res=>{
            toast.clear()
            this.$toast({
              type: 'html',
              icon: 'success',
              overlay: true,
              forbidClick: true,
              duration:3000,
              message:
                '<div style="width:4.6rem">提交成功。</div>',
              size:'large',
              className:'submit-toast',
            });
            this.loading = false
            this.$router.go(-1)
          }).catch(()=>{
            // toast.clear()
            this.loading = false
            // this.$toast.fail('活动太火爆了~稍后再试');
          })
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.zpxq{
  position: relative;
  // padding-top: 110px;
  width: 710px;
  // height: 442px;
  background: url(~@/assets/img/xinxi_bg.png) top center no-repeat;
  background-size: auto 442px;
  padding: 110px 10px 40px;
  margin-bottom: 20px;
  .zi10{
    position: relative;
    z-index: 10;
  }
  &::after{
    content: '';
    position: absolute;
    width: 100%;
    height: 80%;
    // background: url(~@/assets/img/xinxi_bg.png) bottom center no-repeat;
    // background-size: 100% 442px;
    background: #fff;
    left: 0;
    bottom: 0;
    border-radius: 10px;
    z-index: 1;
  }
  .xinxi_title{
    width: 370px;
    height: 76px;
    position: absolute;
    top: 22px;
    left: 22px;
  }
  .zhu{
    color: #ea2525;
    font-family: "PingFang SC";
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.52px;
    padding-left: 32px;
    margin-bottom: 20px;
  }
}
.zpxq1{
  // padding-top: 110px;
  position: relative;
  width: 710px;
  // height: 804px;
  background: url(~@/assets/img/menpiao_bg.png) top center no-repeat;
  background-size: auto 804px;
  padding: 110px 10px 40px ;
  z-index: 99;
  &::after{
    content: '';
    position: absolute;
    width: 100%;
    height: 80%;
    background: #fff;
    left: 0;
    bottom: 0;
    border-radius: 10px;
    z-index: -1;
  }
  .xinxi_title{
    width: 370px;
    height: 76px;
    position: absolute;
    top: 22px;
    left: 22px;
  }
  .zhu{
    color: #ea2525;
    font-family: "PingFang SC";
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.52px;
    padding-left: 32px;
    margin-bottom: 20px;
  }
  .dishi{
    width: 624px;
    margin: 0 auto;
  }
  .dishi1{
    width: 100%;
    height: 94px;
    padding: 0 4px;
    .ding_img{
      width: 28px;
      height: 28px;
      margin-right: 4px;
    }
    .top_img{
      width: 24px;
      height: 24px;
    }
    .bottom_img{
      width: 24px;
      height: 24px;
    }
    p{
      color: #4a5766;
      font-family: "PingFang SC";
      font-size: 32px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.52px;
    }
  }
  .dishi3{
    width: 100%;
    height: 108px;
    margin: 8px 0 ;
    padding: 0 6px 0 10px;
    background: url(~@/assets/img/piao.png) center center no-repeat;
    background-size: 100% 100%;
    h6{
      font-family: "PingFang SC";
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.52px;
      color: #868686;
    }
    &.active{
      background: url(~@/assets/img/selpiao.png) center center no-repeat;
      background-size: 100% 100%;
      h6{
        color: #2e6bf1;
      }
    }
    &.disable{
      opacity: 0.3;
    }
    p{
      color: #95a4c5;
      text-align: right;
      font-family: "PingFang SC";
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.52px;
      margin-right: -10px;
    }
  }
}

.production{
  box-sizing: border-box;
}
.uploadVideos::after{
  border-bottom: 0;
}
/deep/.van-field__label{
    font-size: 16px;
    color: #999999;
    font-weight: 400;
}
/deep/.van-field__control{
  font-size: 16px;
  text-align: right;
}
/deep/.van-field__error-message{
  text-align: right;
}
/deep/.van-uploader__upload{
  width: 200px;
  height: 112px;
}
/deep/.van-uploader__file{
  width: 200px;
  height: 112px;
}
/deep/.van-uploader__mask{
  width: 200px;
  height: 112px;
}
/deep/.van-cell::after{
  display: none;
}
.footerBtn{
  position: fixed;
  left: calc(50% - 241px);
  bottom: env(safe-area-inset-bottom);
  width: 482px;
  height: 104px;
  z-index: 2;
  background: url("~@/assets/img/btn_bg.png") center center no-repeat;
  background-size: cover;
  // background-image: linear-gradient(102deg, #0EE481 0%, #0CD391 35%, #07A5E2 93%);
  box-sizing: initial;
  .submit{
    background: none;
    // background-image: linear-gradient(102deg, #0EE481 0%, #0CD391 35%, #07A5E2 93%);
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: 0;
    font-size: 36px;
    color: #fff;
    font-weight: 500;
  }
}
.videoBox {
  box-sizing: border-box;
  background: #fff;
  padding: 30px;
  iframe {
    border-radius: 10px;
    height: 388px !important;
  }
}
.textarea{
  padding-top: 0;
  /deep/.van-cell__value{
    height: 3.32rem;
    background: #F4F4F4;
    border-radius: .12rem;
  }
  /deep/.van-field__body{
    height:calc(3.32rem - 20px);
    background: #F4F4F4;
    border-radius: .12rem;
  }
  /deep/.van-field__control{
    text-align: left;
    width: 100%;
    height: 100%;
    padding: .2rem;
  }
}
.wrap{
    background: #EDEDED;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 20px 140px;
    width: 100%;
    min-height: 100vh;
}

.hdgz_img{
  position: fixed;
  top: 15px;
  right: 0;
  width: 60px;
  height: 144px;
  z-index:99
}


.overlay1{
    display: flex;
    align-items: center;
    justify-content: center;
  .wrapper{
    width: 642px;
    // height: 682px;
    background: url("~@/assets/img/alert_bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 20px;
    padding: 55px 50px;
    .typeimg{
      width: 100%;
      height: 336px;
      background-size: auto 100%;
      background-position: center center;
      margin: 60px auto 50px;
      margin-bottom: 20px;
    }
    .jp{
      margin: 16px auto;
      .jp_pic{
        width: 462px;
        height: 292px;
        margin: 0 auto;
        display: block;
      }
      .jp_pic1{
        width: 256px;
        height: 240px;
        margin: 50px auto 10px;
      }
      .jp_pic2{
        width: 360px;
        height: 192px;
        margin: 70px auto 10px 120px;
      }
      .jp_pic3{
        width: 221.54px;
        height: 292.48px;
        margin: 10px auto 0 140px;
      }
      .fail_cj{
        width: 158px;
        height: 240px;
        margin: 80px auto 0;
        display: block;
      }
      p{
        // font-size: 26px;
        // color: #999;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 36px;
        color: #999999;
        letter-spacing: 0;
        margin-top: 16px;
        span{
          color: #09c;
        }
      }
      h5{
        // font-size: 26px;
        // color: #999;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 36px;
        color: #333;
        letter-spacing: 0;
        margin-top: 16px;
        span{
          color: #09c;
        }
      }
      
      &.jp1{
        max-height: 60vh;
        overflow: auto;
        padding-left: 25px;
        padding-right: 10px;
        h1{
          height: 42px;
          line-height: 42px;
          font-family: PingFangSC-SNaNpxibold;
          font-weight: 600;
          font-size: 30px;
          color: #333333;
          letter-spacing: 0;
          margin-bottom: 14px;
          margin-top: 10px;
          position: relative;
          &::before{
            content: '';
            width: 12px;
            height: 12px;
            background: #0F93F8;
            border-radius: 4px;
            position: absolute;
            left: -24px;
            top: 15px;
            display: block;
          }
        }
        p{
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          letter-spacing: 0;
          line-height: 40px;
          text-align: left;
          margin-top: 0;
          margin-bottom: 10px;
          // text-indent: 2em;
          mark{
            color: #1b2a5a;
            font-family: "PingFang SC";
            font-size: 32px;
            font-style: normal;
            font-weight: 600;
            line-height: 56px;
          }
        }
      }
    }
    .close{
      width: 30px;
      height: 30px;
      display: block;
      position: absolute;
      right:28px;
      top: 44px;
    }
    .tbl_btn{
      width: 298px;
      height: 98px;
      margin: 30px auto 0;
      display: block;
    }
    .overlay_title2{
        font-family: PingFangSC-SNaNpxibold;
        font-weight: 600;
        font-size: 46px;
        color: #DB0404;
        letter-spacing: 0;
        line-height: 54px;
      text-align: center;
    }
    .overlay_title{
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 44px;
      color: #0F93F8;
      letter-spacing: 0;
      height: 44px;
      line-height: 44px;
      color: #0F93F8;
      margin-bottom: 0px;
      text-align: center;
      span{
        position: relative;
         &::after{
           content: '';
           background-image: linear-gradient(90deg, #0F93F89a 0%, #fff 100%);
           width: 80px;
           height: 8px;
           left: -90px;
           top: 27px;
           display: block;
           position: absolute;
         }
         &::before{
           content: '';
           background-image: linear-gradient(-90deg, #0F93F89a 0%, #fff 100%);
           width: 80px;
           height: 8px;
           right: -90px;
           top: 27px;
           display: block;
           position: absolute;
         }

      }
    }
    .overlay_title1{
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 42px;
      letter-spacing: 0;
      height: 42px;
      line-height: 42px;
      color: #0F93F8;
      margin-bottom: 40px;
      text-align: center;
    }
    .overlay_btn1{
      margin-top: 50px;
    }
    .overlay_btn2{
      margin-top: 50px;
    }
    .overlay_btn3{
      margin-top: 50px;
    }
    .overlay_text{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: #666666;
      letter-spacing: -0.48px;
      text-align: center;
      line-height: 44px;
      margin-top: 80px;
      margin-bottom: 60px;
    }
  }
}
</style>
<style>
.submit-toast{
  width: 4.8rem;
}
</style>